var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuWireless = function SvgIconMenuWireless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.601,
    height: 16.879
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.437 5.433a13.734 13.734 0 0 1 18.779 0c.715.656 1.908-.537 1.133-1.252a15.407 15.407 0 0 0-21.1 0c-.775.715.477 1.967 1.192 1.252Z",
    "data-name": "Path 5790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.822 7.877a10.22 10.22 0 0 1 13.95-.06c.715.715 1.967-.477 1.192-1.192a11.894 11.894 0 0 0-16.275 0c-.775.715.417 1.908 1.133 1.252",
    "data-name": "Path 5791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.265 10.261a6.836 6.836 0 0 1 9.121 0c.715.656 1.908-.537 1.133-1.252a8.57 8.57 0 0 0-11.446 0c-.775.715.417 1.908 1.192 1.252",
    "data-name": "Path 5792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.651 12.706a3.67 3.67 0 0 1 4.352 0c.715.6 1.908-.6 1.133-1.312a5.29 5.29 0 0 0-6.617 0c-.835.715.358 1.908 1.133 1.312Z",
    "data-name": "Path 5793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.406 15.269a1.61 1.61 0 0 1-3.219 0 1.611 1.611 0 1 1 3.219 0",
    "data-name": "Path 5794"
  }))));
};
export default SvgIconMenuWireless;